import React from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../_redux/invoicesActions';
import can from '../../../_common/components/Permissions/can';

export function DownloadInvoice({cellContent}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${(can('full', 'invoices')) ? `` : `opacity-30`}`;
  const buttonLabel = intl.formatMessage({
    id: 'invoices-button-downloadInvoice',
    defaultMessage: 'Download invoice',
  });

  return (
    <div
      className={buttonClassName}
      onClick={() => {
        if (can('full', 'invoices')) {
          dispatch(actions.downloadInvoice({
            invoiceTypeID: cellContent.type,
            invoiceNum: cellContent.num,
            name: cellContent._id
          }))
        }
      }}
    >
      {buttonLabel}
      <img
        src={toAbsoluteUrl('/media/svg/Download_brandColor.svg')}
        alt="icon"
        className={'w-30px h-30px ml-2'}
      />
    </div>
  )
}

export default DownloadInvoice;